import React, { useEffect } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { STORAGE_KEYS } from "../../common/constants/Storage";
import { setStorage } from "../../common/constants/Services";
import ScrolltoTop from "../../components/ScrolltoTop";
import logoutImage from "../../assets/images/logout.webp";
import bannerImage from "../../assets/images/banner.webp";
import { useTranslation } from "react-i18next";
const SignOut = () => {
  const { t } = useTranslation("translation");
  document.title = t("home.dangxuat");

  useEffect(() => {
    setStorage(STORAGE_KEYS.ACCESS_TOKEN, '');
    setStorage(STORAGE_KEYS.REFRESH_TOKEN, '');
    setStorage(STORAGE_KEYS.EXPIRED_TOKEN, '');
    setStorage(STORAGE_KEYS.FULL_NAME, '');
    setStorage(STORAGE_KEYS.AVATAR, '');
    setStorage(STORAGE_KEYS.ROLE, '');
  }, []);

  return (
    <React.Fragment>
      <div>
        <div className="main-content">
          <div className="page-content">
            <section className="bg-auth">
              <Container>
                <Row className="justify-content-center">
                  <Col xl={10} lg={12}>
                    <Card className="auth-box">
                      <Row>
                        <Col lg={6} className="text-center">
                          <CardBody className="p-4">
                            <Link to="/">
                              <img
                                src={bannerImage}
                                alt=""
                                className="logo-light"
                              />
                              <img
                                src={logoutImage}
                                alt=""
                                className="logo-light"
                              />
                              <img
                                src={bannerImage}
                                alt=""
                                className="logo-dark"
                              />
                              <img
                                src={logoutImage}
                                alt=""
                                className="logo-dark"
                              />
                            </Link>
                          </CardBody>
                        </Col>
                        <Col lg={6}>
                          <div className="auth-content card-body p-5 text-white">
                            <div className="w-100">
                              <div className="text-center mb-4">
                                <h5>{t("Bạn đã đăng xuất")}</h5>
                                <p className="text-white-70">
                                  {t("Cảm ơn bạn đã đến với TopJob360")}
                                </p>
                              </div>
                              <Link
                                to="/signin"
                                className="btn btn-white btn-hover w-100"
                              >
                                {t("home.dangnhap")}
                              </Link>
                              <div className="mt-3 text-center">
                                <p className="mb-0">
                                  {t("Bạn chưa có tài khoản ?")}{" "}
                                  <Link
                                    to="/signup"
                                    className="fw-medium text-white text-decoration-underline"
                                  >
                                    {" "}
                                    {t("home.dangky")}{" "}
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
                <ScrolltoTop />
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignOut;
